module.exports = __webpack_public_path__ + "img/4.03.81c9d3d5.jpg";